module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "unauthorized"
  }, [_vm._v("\n  " + _vm._s(_vm.$t(_vm.error)) + "\n  "), _c('div', {
    staticClass: "get-back"
  }, [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_vm._v("\n      " + _vm._s(_vm.$t('ui.global.back_to_home')) + "\n    ")])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6c5908ba","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/Unauthorized.vue
// module id = 1932
// module chunks = 0